import { createSlice, createReducer, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import NavbarSlice from '../navbar/NavbarSlice';
import {host} from '../../function/api'

let initialState = {
    documents: [],
    internetMessage: '',
    status: false,
    loading: false,
    message: '',
    messeageCustomer: '',
    success: false,
    documentItem: [],
    documentId: '',
    customerStore: false,
    errorName: '',
    errorFamily: '',
    errorNationalCode: '',
    errorNumberType: '',
    errorNumber: '',
    errorFather: '',
    errorBirthplace: '',
    errorIdcard: '',
    errorBirthregistrationdate: '',
    errorPlaceofissue: '',
    errorMobile: '',
    errorPostalcode: '',
    errorPhone: '',
    errorAddress: ''
}
export const uploadImage = createAsyncThunk(
    'document/request/uploadImage',
    async(data , thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}documentRequest/uploadImage`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        // 'withCredentials': true,
                        "Content-Type": "multipart/form-data",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
            
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message());
        }
    }
)
export const documentStoreWithOutId = createAsyncThunk(
    'document/request/storeWithOutId',
    async(data , thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}documentRequest/storeWithOutId`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
            
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const documentRequestStore = createAsyncThunk(
    'document/request/store',
    async(data , thunkAPI) => {
        try{
            console.log(data)
            const response = await axios({
                method: 'POST',
                url: `${host}documentRequest`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
            
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentRequestIndex = createAsyncThunk(
    'document/request/index',
    async(token, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}documentRequest`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,     
                }
            })

            return response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentSearch = createAsyncThunk(
    'documentrequestSearch',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}document/search`,
                data: data,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            return await response.data
            
        } catch(error) {
            return thunkAPI.rejectWithValue(error);
        }

    }
)

export const documentUpdate = createAsyncThunk(
    'document/update',
    async(data, thunkAPI) => {
        try {
            console.log(data)
            const response = await axios({
                method: 'POST',
                url: `${host}customer`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            return await response.data

        } catch(error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const documentRequestSlice = createSlice({
    name: 'documentRequest',
    initialState,
    reducers: {
        // internetMessageChange
    },
    extraReducers: {
        [documentRequestStore.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.success = true
            state.message = payload.message;
        },
        [documentRequestStore.pending] : (state) => {
            state.loading = true    
            state.success = false
        },
        [documentRequestStore.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            if(payload.response.data.error) {
                state.nameDocumentId = payload.response.data.error.documentId
                state.nameError = payload.response.data.error.name
                state.familyError = payload.response.data.error.family
                state.nationalIdError = payload.response.data.error.nationalId
                state.numberTypeError = payload.response.data.error.numberType
                state.numberError = payload.response.data.error.number
                state.errorFather = payload.response.data.error.father
                state.errorBirthplace = payload.response.data.error.birthplace
                state.errorIdcard = payload.response.data.error.idcard
                state.errorBirthregistrationdate = payload.response.data.error.birthregistrationdate
                state.errorPlaceofissue = payload.response.data.error.placeofissue
                state.errorMobile = payload.response.data.error.mobile
                state.errorPostalcode = payload.response.data.error.pastalCode
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
            
        },
        [documentRequestIndex.fulfilled]: (state, action) => {
            state.loading = false
            // state.success = true
            state.documents = action.payload.data.data
        },
        [documentRequestIndex.pending]: (state) => {
            state.loading = true
        },
        [documentRequestIndex.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [documentSearch.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.documentItem = action.payload.data
            if(action.payload.message)
            state.message = action.payload.message;
            state.internetMessage = action.payload.message
            if(action.payload.message) {
                state.internetMessage = action.payload.message
            }
        },
        [documentSearch.pending]: (state) => {
            state.loading = true
            state.success = false;
            state.status = false;
            
        },
        [documentSearch.rejected]: (state, action) => {
            state.loading = false;
            state.success = false
            state.status = false;
            state.message = action.payload.response.data.message;
            state.documentItem = {}
            console.log(action.payload.response.data)
            if(action.payload.response.data.error){
                state.errorNumberType = action.payload.response.data.error.numberType
                state.ErrorNumber = action.payload.response.data.error.number
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            } else {
                state.message = 'اینترنت را چک کنید'
            }
        },
        [documentUpdate.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.success = true
            state.customerStore = true
            state.message = payload.message
            state.errorDocumentId = ''
            state.errorName = ''
            state.errorFamily = ''
            state.errorNationalCode = ''
            state.errorFather = ''
            state.errorBirthplace = ''
            state.errorIdcard = ''
            state.errorBirthregistrationdate = ''
            state.errorPlaceofissue = ''
            state.errorMobile = ''
            state.errorPostalcode = ''
            state.errorPhone = ''
            state.errorAddress = ''
        },
        [documentUpdate.pending] : (state) => {
            state.loading = true    
            state.success = false
            state.customerStore = true
        },
        [documentUpdate.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            state.customerStore = true
            console.log(payload.response.data.error.nationalCode)
            if(payload.response.data.error) {
                state.errorDocumentId = payload.response.data.error.documentId
                state.errorName = payload.response.data.error.name
                state.errorFamily = payload.response.data.error.family
                state.errorNationalCode = payload.response.data.error.nationalCode
                state.errorFather = payload.response.data.error.father
                state.errorBirthplace = payload.response.data.error.birthplace
                state.errorIdcard = payload.response.data.error.idcard
                state.errorBirthregistrationdate = payload.response.data.error.birthregistrationdate
                state.errorPlaceofissue = payload.response.data.error.placeofissue
                state.errorMobile = payload.response.data.error.mobile
                state.errorPostalcode = payload.response.data.error.postalcode
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }   
        },
        [documentStoreWithOutId.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.customerStore = true
            state.messeageCustomer = payload.message;
        },
        [documentStoreWithOutId.pending] : (state) => {
            state.loading = true    
            state.customerStore = false
        },
        [documentStoreWithOutId.rejected]: (state, {payload}) => {
            state.loading = false
            state.customerStore = false
            if(payload.response.data.error) {
                state.nameError = payload.response.data.error.name
                state.familyError = payload.response.data.error.family
                state.errorNationalCode = payload.response.data.error.nationalCode
                state.numberTypeError = payload.response.data.error.numberType
                state.numberError = payload.response.data.error.number
                state.errorFather = payload.response.data.error.father
                state.errorBirthplace = payload.response.data.error.birthplace
                state.errorIdcard = payload.response.data.error.idcard
                state.errorBirthregistrationdate = payload.response.data.error.birthregistrationdate
                state.errorPlaceofissue = payload.response.data.error.placeofissue
                state.errorMobile = payload.response.data.error.mobile
                state.errorPostalcode = payload.response.data.error.pastalCode
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }else if(payload.response.data.message) {
                state.messeageCustomer = payload.response.data.message
            }
            
        },
        [uploadImage.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.success = true
            state.status = true
            state.message = payload.message
            state.errorFile = ''
            state.errorUploadType = ''
        },
        [uploadImage.pending] : (state) => {
            state.loading = true    
            state.success = false
            state.status = false
        },
        [uploadImage.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            state.status = false
            if(payload.response.data.error) {
                state.errorFile = payload.response.data.error.file
                state.errorUploadType = payload.response.data.error.uploadType
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
            
        }
    }
})

export const {} = documentRequestSlice.actions;
export default documentRequestSlice.reducer;
